export const deleteOperation = (
  workoutSectionId: number,
  inputContent: string,
) => {
  const parsedContent = JSON.parse(inputContent);
  return JSON.stringify(
    parsedContent.filter((element) => element.id !== workoutSectionId),
  );
};
